function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-118 -637) translate(118 637) translate(3 3)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.755 12.847c-.575.027-1.01-.147-1.501-.285-.519-.145-.829-.313-1.098.312-.288.668.145.826.687.924 1.244.225 2.32.71 3.346 1.31.496.29.846.603.462 1.1-.396.515-2.908.786-5.63.786-2.027 0-5.182-.293-5.58-.817-.393-.519.097-.825.542-1.093 1.016-.61 2.131-1.04 3.349-1.314.568-.127 1.11-.313.75-1.014-.3-.584-.684-.703-1.35-.457-3.026 1.12-5.376.145-6.875-2.415C-.395 7.747-.162 7.456 2.544 6.988c3.815-.659 6.322 1.033 6.689 3.948.071.568.345 1.12.96 1.1.568-.02.84-.642.802-1.142-.22-2.91 3.862-4.248 6.594-3.464.672.192.92.458.759 1.148-.416 1.777-1.161 3.284-3.346 4.028-.265.09-.68.17-1.247.24z",
  transform: "translate(0 .025)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.678 3.183c.075 1.105-.737 1.953-1.645 1.953s-1.71-.91-1.645-1.953C9.455 2.106 11.033.055 11.033.055s1.571 2.052 1.645 3.128",
  transform: "translate(0 .025)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.689 1.785c.037.552-.368.976-.822.976-.453 0-.853-.455-.82-.976C.08 1.248.866.224.866.224s.785 1.024.822 1.561",
  transform: "translate(6.85 3.069)"
}))))));

var SvgDefault = function SvgDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default.2535fd88.svg";
export { ForwardRef as ReactComponent };